import { Injectable, inject } from "@angular/core";

import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, ICardData, IdValuePair, } from "@tylertech/tyler-api-types";

import
{
    AccountsChartData,
    AccountsChartParams,
    CatchupBillingCriteria,
    NewPacketTemplateDTO,
    PacketProgress,
    ServiceOrdersChartData,
    ServiceOrdersChartParams,
    TodoItemDTO,
    UBBillingCyclePeriodDTO,
} from "../interfaces";

export type Dictionary<T> = Record<string, T>;

@Injectable()
export class UBDashboardService
{
    private readonly $apiService = inject(ApiService);


    deleteNewPacketTemplate(item: NewPacketTemplateDTO): Promise<boolean>
    {
        return this.$apiService.sendAuth("IUBDashboardService/DeleteNewPacketTemplate", item);
    }

    getAccountsChartData(params: AccountsChartParams): Promise<AccountsChartData>
    {
        return this.$apiService.sendAuth("IUBDashboardService/GetAccountsChartData", params);
    }

    getBillingCycleBillingChartData(billingCyclePeriod: UBBillingCyclePeriodDTO): Promise<ICardData>
    {
        return this.$apiService.sendAuth("IUBDashboardService/GetBillingCycleBillingChartData", billingCyclePeriod);
    }

    getBillingCycleMeterReadingChartData(billingCyclePeriod: UBBillingCyclePeriodDTO): Promise<ICardData>
    {
        return this.$apiService.sendAuth(
            "IUBDashboardService/GetBillingCycleMeterReadingChartData",
            billingCyclePeriod
        );
    }

    getBillingCyclePastDueChartData(billingCyclePeriod: UBBillingCyclePeriodDTO): Promise<ICardData[]>
    {
        return this.$apiService.sendAuth("IUBDashboardService/GetBillingCyclePastDueChartData", billingCyclePeriod);
    }

    getModules(): Promise<Dictionary<string>>
    {
        return this.$apiService.sendAuth("IUBDashboardService/GetModules");
    }

    getNewPacketTemplates(): Promise<NewPacketTemplateDTO[]>
    {
        return this.$apiService.sendAuth("IUBDashboardService/GetNewPacketTemplates");
    }

    getPacketProgress(): Promise<PacketProgress[]>
    {
        return this.$apiService.sendAuth("IUBDashboardService/GetPacketProgress");
    }

    getPathToPayPaymentPlan(paymentPlanId: string): Promise<string>
    {
        return this.$apiService.sendAuth("IUBDashboardService/GetPathToPayPaymentPlan", paymentPlanId);
    }

    getProcessTypes(moduleName: string): Promise<Dictionary<string>>
    {
        return this.$apiService.sendAuth("IUBDashboardService/GetProcessTypes", moduleName);
    }


    getRecentBillingCyclePeriods(numberOfPeriods: number): Promise<UBBillingCyclePeriodDTO[]>
    {
        return this.$apiService.sendAuth("IUBDashboardService/GetRecentBillingCyclePeriods", numberOfPeriods);
    }

    getServiceOrdersChartData(params: ServiceOrdersChartParams): Promise<ServiceOrdersChartData[]>
    {
        return this.$apiService.sendAuth("IUBDashboardService/GetServiceOrdersChartData", params);
    }

    getTodoItems(): Promise<TodoItemDTO[]>
    {
        return this.$apiService.sendAuth("IUBDashboardService/GetTodoItems");
    }

    processCatchUpBillingPacket(originalPacketId: string): Promise<ExecutionResult<string>>
    {
        return this.$apiService.sendAuth("IUBDashboardService/ProcessCatchUpBillingPacket", originalPacketId);
    }

    processCatchUpBillingSingleAccount(criteria: CatchupBillingCriteria): Promise<ExecutionResult<string>>
    {
        return this.$apiService.sendAuth("IUBDashboardService/ProcessCatchUpBillingSingleAccount", criteria);
    }

    rejectServiceRequest(request: IdValuePair): Promise<boolean>
    {
        return this.$apiService.sendAuth("IUBDashboardService/RejectServiceRequest", request);
    }

    saveNewPacketTemplate(item: NewPacketTemplateDTO): Promise<boolean>
    {
        return this.$apiService.sendAuth("IUBDashboardService/SaveNewPacketTemplate", item);
    }

    saveTodoItem(item: TodoItemDTO): Promise<TodoItemDTO>
    {
        return this.$apiService.sendAuth("IUBDashboardService/SaveTodoItem", item);
    }
}
